import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonItem, IonLabel, IonInput, IonButton, IonCheckbox, IonText, IonTextarea, IonAlert, IonIcon, IonCard, IonImg, IonGrid, IonCol, IonRow, IonRouterLink } from '@ionic/react';
import { useParams } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';
import ListItems from '../components/ListItems';
import InnerMenu from '../components/InnerMenu';
import GpsSinglePointComponent from '../components/GpsSinglePointComponent';
import { useForm } from "react-hook-form";
import { Device } from '@capacitor/device';
import PageEventHandler from "../components/PageEventHandler"
import './Feedback.css';
import { BASE_URL } from '../utils/constant';
import { Camera, CameraResultType } from '@capacitor/camera';
import { LanguageContext } from '../contexts/LanguageContext';
import { feedbackTranslations } from '../translations/feedback';
import NotificationRedirect from '../components/NotificationRedirect';

const Feedback: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const t = feedbackTranslations[language];

  const pageName = "Invio segnalazioni";
  const [userCoords, setUserCoords] = useState<any | null>(null)
  const [showAlert, setShowAlert] = useState(false);
  const [alertTit, setAlertTit] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [deviceId, setDeviceId] = useState("-");
  const { register, formState: { errors }, handleSubmit, reset } = useForm();
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(true);
  const [pictures, setPictures] = useState<any[]>([])

  // retrieve the device UUID
  const getDeviceInfo = async () => {
    const devId = await Device.getId();
    setDeviceId(devId.identifier);
  };

  // call function to retrieve the device UUID
  useEffect(() => {
    getDeviceInfo();
  }, []);

  function dataUrlToBlob(dataUrl: string): Blob {
    const byteString = atob(dataUrl.split(',')[1]);
    const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([arrayBuffer], { type: mimeString });
  }

  // send post req to save data
  const sendFeedback = async (data: any) => {
    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('email', data.email)
    formData.append('message', data.message)
    formData.append('userAgent', window.navigator.userAgent)
    formData.append('lat', (userCoords != null ? userCoords.latitude : 0))
    formData.append('lng', (userCoords != null ? userCoords.longitude : 0))
    formData.append('uuid', deviceId)
    formData.append('h', "gkzLoFk0MN58TGqCJj")
    formData.append('act', '3')
    for (var i = 0; i < pictures?.length; i++) {
      const blob = await dataUrlToBlob(pictures[i].dataUrl);
      
      formData.append(`images[${i}]`, blob,`image_${new Date().toJSON().slice(0,10)}_${i}.${pictures[i].format}`)
    }

    const url = `${BASE_URL}/poServer.php`;
    fetch(url, {
      method: 'post',
      mode: 'cors', // this has to be 'cors'
      body: formData,
      headers: {
        'Accept': 'application/json',
      }
    })
      .then(res => res.json())
      .then(
        (response) => {
          console.log(response)
          setAlertTit(t.successTitle)
          setAlertMessage(t.successMessage);
          setShowAlert(true);
          reset();
        },
        (error) => {
          if (error && error.message ) 
          {
            console.log('Server problem: ', error.message);
            setAlertTit(t.serverErrorTitle)
            setAlertMessage(t.serverErrorMessage);
            setShowAlert(true);
          }
          else
          {
            setAlertTit(t.successTitle)
            setAlertMessage(t.successMessage);
            setShowAlert(true);
            reset();
          }
        })
      .catch(error => {
        console.log('Message sending problem: ', error);
        setAlertTit(t.sendErrorTitle)
        setAlertMessage(t.sendErrorMessage);
        setShowAlert(true);
      });
  }

  const takePicture = async () => {
    try {
      const image = await Camera.getPhoto({
        quality: 100,
        allowEditing: false,
        resultType: CameraResultType.DataUrl,
      });
      if(image){
        await setPictures([...pictures, image])
      }
    } catch (error) {
      console.log(error)
    }
  };

  const removeImage = async (index: number) => {
    const images = await pictures.filter((item, i) => i !== index)
    setPictures(images)
  }

  return (
    <IonPage>
      <IonHeader>
        <InnerMenu name={t.pageTitle} />
      </IonHeader>
      <IonContent fullscreen>
        <IonItem lines="none">
          <h1 className="mainTit" slot="start">{t.pageTitle}</h1>
        </IonItem>
        <div className="ion-padding ion-text-justify">
          {t.description}
        </div>
        <form className="ion-padding" onSubmit={handleSubmit(sendFeedback)}>
          <IonItem>
            <IonInput label={t.nameLabel} {...register("name", { required: true, maxLength: 20 })} />
            {errors.name?.type === 'required' &&
              <IonText color="danger" className="ion-padding-start">
                <small>{t.nameError}</small>
              </IonText>
            }
          </IonItem>
          <IonItem>
            <IonInput label={t.emailLabel} {...register("email", { required: true, pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i, minLength: 8 })} type="email" />
            {errors.email?.type === 'required' &&
              <IonText color="danger" className="ion-padding-start">
                <small>{t.emailRequired}</small>
              </IonText>
            }
            {errors.email?.type === 'pattern' &&
              <IonText color="danger" className="ion-padding-start">
                <small>{t.emailInvalid}</small>
              </IonText>
            }
          </IonItem>
          <IonItem>
            <IonTextarea label={t.messageLabel} rows={6} cols={20} {...register("message", { required: true })}></IonTextarea>
          </IonItem>
          {errors.message?.type === 'required' &&
            <IonText color="danger" className="ion-padding-start">
              <small>{t.messageError}</small>
            </IonText>
          }
          {pictures &&
            <IonGrid class='picture-container' >
              <IonRow>
                {pictures?.map((image, index) => {
                  const blob = dataUrlToBlob(image.dataUrl);
                  const blobUrl = URL.createObjectURL(blob);
                  return (
                    <IonCol key={index}>
                      <IonImg src={blobUrl} className='picture' />
                      <IonIcon icon="./assets/images/close.svg" className="close-icon" onClick={() => removeImage(index)} />
                    </IonCol>
                  )
                })}
              </IonRow>
            </IonGrid>
          }
          <IonButton className="ion-margin-top uploadBtn" expand="block" shape='round' fill='outline' onClick={() => takePicture()}>
            {t.uploadButton}
          </IonButton>
          <IonItem>
            <IonLabel><h4>{t.privacyLabel1} <IonRouterLink routerLink="/rulebook">Privacy Policy</IonRouterLink> {t.privacyLabel2}</h4></IonLabel>
            <IonCheckbox  color="success" slot="start" onIonChange={(e) => e.detail.checked ? setSubmitBtnDisabled(false) : setSubmitBtnDisabled(true)} />
          </IonItem>
          <IonButton className="ion-margin-top feedSubBtn" type="submit" expand="block" disabled={submitBtnDisabled} id="submitBtn">
            {t.submitButton}
          </IonButton>
        </form>
      </IonContent>
      <IonAlert
        header={alertTit}
        isOpen={showAlert} message={alertMessage} buttons={[{ text: 'Ok' }]} onDidDismiss={() => setShowAlert(false)} />
      <GpsSinglePointComponent setUserCoords={setUserCoords} /> {/* pass the setter function to the child so we maintain the state watcher */}
      <PageEventHandler pageIndex={11} dockIndex={0} />
      <NotificationRedirect /> {/* redirect to the page specified in the local storage */}
    </IonPage>
  );
};

export default Feedback;
